// Pure route-path constants and URL builders. Deliberately free of React / page
// imports so shared utilities (e.g. utilities/chartUtils) can reference route URLs
// without pulling the entire page/router graph (and its heavy deps like `three`)
// into non-UI code and unit tests.

export const DefaultRoutes = {
  HomePage: '/',
  UsersPage: '/users',
  DataIntegrationPage: '/dataIntegration',
  PlayerPerformancePage: '/playerPerformance',
  MeasurementDetailPage: '/measurements',
  InviteExpiredPage: '/invite_expired',
  SharedSessionsPage: '/sharedsession',
  AppRedirectPage: '/appredirect',
} as const;

export function measurementDetailUrl(sessionId: string, measurementId: string, playerId?: string | null): string {
  const player = playerId ? `&playerId=${encodeURIComponent(playerId)}` : '';
  return `${DefaultRoutes.MeasurementDetailPage}?sessionId=${encodeURIComponent(sessionId)}&measurementId=${encodeURIComponent(measurementId)}${player}`;
}

/** A player's performance page; `kindFilter` picks the session-type tab (e.g. 'Penalties'), omitted = the default tab. */
export function playerPerformanceUrl(playerId: string, kindFilter?: string | null): string {
  const params = new URLSearchParams({ player: playerId });
  if (kindFilter) params.set('type', kindFilter);
  return `${DefaultRoutes.PlayerPerformancePage}?${params.toString()}`;
}

/** Opens a session's page focused on the player's first kick (the BFF resolves the kick). */
export function sessionPlayerUrl(sessionId: string, playerId: string): string {
  return `${DefaultRoutes.MeasurementDetailPage}?sessionId=${encodeURIComponent(sessionId)}&playerId=${encodeURIComponent(playerId)}`;
}
